import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { ModalComponent } from '../../modal/modal.component';
import { ActionsCompletedPluginService } from './actions-completed-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';

@Component({
  selector: 'actions-completed-edit',
  templateUrl: './actions-completed-edit.component.html',
  standalone: false
})
export class ActionsCompletedEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  plugin: any;
  editForm: UntypedFormGroup;
  public currentItem: any;
  public processing = false;
  private actionToRemove: number;

  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;
  @ViewChild('actionDeleteConfirm', { static: true }) actionDeleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ActionsCompletedPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateActions(this.inspectionId, this.pointId, this.pluginId, model.actions).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['actions'];
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['actions'];
    control.push(this.initAction());
  }

  initForm() {
    this.editForm = this.fb.group({
      actions: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['actions'];
    _.forEach(this.plugin.config.Actions, (el) => {
      control.push(this.initAction(el));
    });
  }

  initAction(el?: any) {
    return this.fb.group({
      Description: new UntypedFormControl(el && el.Description ? el.Description : ''),
      Hours: new UntypedFormControl(el && el.Hours !== null && el.Hours !== undefined ? el.Hours : null),
      Minutes: new UntypedFormControl(el && el.Minutes !== null && el.Minutes !== undefined ? el.Minutes : null),
      Comment: new UntypedFormControl(el && el.Comment ? el.Comment : ''),
      Id: el && el.Id
    });
  }

  remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['actions'];
    control.removeAt(this.actionToRemove);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openActionDeleteConfirm(i: number) {
    this.actionDeleteConfirm.open();
    this.actionToRemove = i;
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
